// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__nioS5","col":"styles_col__1yDJQ"};